// extracted by mini-css-extract-plugin
module.exports = {"userPraiseChart":"platformRelated_userPraiseChart__3uwSc","title":"platformRelated_title__BtS0A"};